import { withSvgIcon } from './withSvgIcon';

export const Cross = withSvgIcon(
  <path
    fillRule="evenodd"
    clipRule="evenodd"
    d="M16.2071 9.20714L16.9142 8.50003L15.5 7.08582L14.7929 7.79292L12 10.5858L9.20714 7.79292L8.50003 7.08582L7.08582 8.50003L7.79292 9.20714L10.5858 12L7.79292 14.7929L7.08582 15.5L8.50003 16.9142L9.20714 16.2071L12 13.4142L14.7929 16.2071L15.5 16.9142L16.9142 15.5L16.2071 14.7929L13.4142 12L16.2071 9.20714Z"
    fill="currentColor"
  />,
  { viewBox: '0 0 24 24' },
);
